import { fetchUtils, DataProvider } from 'ra-core'

const resourceToEndpointMapping = (resource: string): string => {
  if (resource === 'assets' || resource === 'subassets') {
    return "asset-manager"
  } else if (resource == 'multilang-jobs' || resource == 'tablets') {
    return "portal/api"
  } else if (resource.startsWith('pricingrules')) {
    return "/api/workflow"
  }
  return "/api/admin"
}

const transformPricingRulesResource = (resource: string): string => {
  if (resource === 'pricingrules/dynamic' || resource === 'pricingrules/fixed') {
    return 'pricingrules'
  }
  return resource
}

const addPricingRulesFilter = (resource: string, params: any): any => {
  if (resource === 'pricingrules/dynamic') {
    return {
      ...params,
      filter: { ...params.filter, types: 'DYNAMIC' }
    }
  } else if (resource === 'pricingrules/fixed') {
    return {
      ...params,
      filter: { ...params.filter, types: ['FIXED', 'FIXED_ASSET_BASED'] }
    }
  }
  return params
}
  
export default (delegateDataProvider: (apiUrl: string, httpClient?: any) => DataProvider, httpClient = fetchUtils.fetchJson): DataProvider => ({
  getList: (resource, params) => {
    const endpoint = resourceToEndpointMapping(resource)
    const transformedResource = transformPricingRulesResource(resource)
    const transformedParams = addPricingRulesFilter(resource, params)
    const delegate = delegateDataProvider(endpoint, httpClient)
    return delegate.getList(transformedResource, transformedParams)
  },
  getOne: (resource, params) => {
    const endpoint = resourceToEndpointMapping(resource)
    const transformedResource = transformPricingRulesResource(resource)
    const delegate = delegateDataProvider(endpoint, httpClient)
    return delegate.getOne(transformedResource, params)
  },
  getMany: (resource, params) => {
    const endpoint = resourceToEndpointMapping(resource)
    const transformedResource = transformPricingRulesResource(resource)
    const delegate = delegateDataProvider(endpoint, httpClient)
    return delegate.getMany(transformedResource, params)
  },
  getManyReference: (resource, params) => {
    const endpoint = resourceToEndpointMapping(resource)
    const transformedResource = transformPricingRulesResource(resource)
    const transformedParams = addPricingRulesFilter(resource, params)
    const delegate = delegateDataProvider(endpoint, httpClient)
    return delegate.getManyReference(transformedResource, transformedParams)
  },
  update: (resource, params) => {
    const endpoint = resourceToEndpointMapping(resource)
    const transformedResource = transformPricingRulesResource(resource)
    const delegate = delegateDataProvider(endpoint, httpClient)
    return delegate.update(transformedResource, params)
  },
  updateMany: (resource, params) => {
    const endpoint = resourceToEndpointMapping(resource)
    const transformedResource = transformPricingRulesResource(resource)
    const delegate = delegateDataProvider(endpoint, httpClient)
    return delegate.updateMany(transformedResource, params)
  },
  create: (resource, params) => {
    const endpoint = resourceToEndpointMapping(resource)
    const transformedResource = transformPricingRulesResource(resource)
    const delegate = delegateDataProvider(endpoint, httpClient)
    return delegate.create(transformedResource, params)
  },
  delete: (resource, params) => {
    const endpoint = resourceToEndpointMapping(resource)
    const transformedResource = transformPricingRulesResource(resource)
    const delegate = delegateDataProvider(endpoint, httpClient)
    return delegate.delete(transformedResource, params)
  },
  deleteMany: (resource, params) => {
    const endpoint = resourceToEndpointMapping(resource)
    const transformedResource = transformPricingRulesResource(resource)
    const delegate = delegateDataProvider(endpoint, httpClient)
    return delegate.deleteMany(transformedResource, params)
  }
})